import * as React from "react";

import { useSchematicBuilderContext } from "../SchematicBuilderContext";
import { scaffold, ScaffoldedFile } from "./scaffold";

export function useScaffolder(): () => ScaffoldedFile[] {
  const {
    basePath,
    basePackage,
    baseDir,
    schematicKinds,
    scaffolders,
    getRootSchematic,
  } = useSchematicBuilderContext();
  return React.useCallback(() => {
    const schematic = getRootSchematic();
    return scaffold(
      schematic,
      typeof scaffolders === "function" ? scaffolders(schematic) : scaffolders,
      {
        schematicKinds,
        basePath,
        basePackage,
        baseDir: typeof baseDir === "function" ? baseDir(schematic) : baseDir,
      },
    );
  }, [
    baseDir,
    basePackage,
    basePath,
    getRootSchematic,
    scaffolders,
    schematicKinds,
  ]);
}
